import { render, staticRenderFns } from "./TerminalNotification.vue?vue&type=template&id=362954f7&scoped=true"
import script from "./TerminalNotification.vue?vue&type=script&lang=js"
export * from "./TerminalNotification.vue?vue&type=script&lang=js"
import style0 from "./TerminalNotification.vue?vue&type=style&index=0&id=362954f7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "362954f7",
  null
  
)

export default component.exports